<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Excel Import', apiMethod: 'ExcelImports', form: () => import('../forms/ExcelImportForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Excel Import Error', apiMethod: 'ExcelImportErrors', parentForeignKey: 'excelImportId', form: () => import('../forms/ExcelImportErrorForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Errors', value: 'excelImportId', isCard: true, table: () => import('../tables/ExcelImportErrorsTable') },
                ],
                mainForm: () => import('../forms/ExcelImportForm'),
                claimName: 'ExcelImports',
                apiMethod: 'ExcelImports',
            }
        }
    };
</script>
